import { render } from "./BackCabinetBtn.vue?vue&type=template&id=44649144&scoped=true"
import script from "./BackCabinetBtn.vue?vue&type=script&lang=js"
export * from "./BackCabinetBtn.vue?vue&type=script&lang=js"

import "./BackCabinetBtn.vue?vue&type=style&index=0&id=44649144&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44649144"]])

export default __exports__